import { ChevronSelectorVertical } from 'assets/icons';
import { VaultAvatar } from 'common/vault-avatar';
import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { AppContext } from 'context';
import { classnames, isLockedVault, isRestrictedVault } from 'helpers/utils';
import { useClickOutside } from 'hooks/click-outside';
import { useContext, useRef, useState } from 'react';
import styles from './vault-switcher.module.scss';
import { Menu } from './components/menu';

type VaultSwitcherProps = {
  vault: VaultType;
  onVaultSelect: (vaultId: number) => void;
  compact?: boolean;
};

export const VaultSwitcher: React.FC<VaultSwitcherProps> = ({
  vault,
  onVaultSelect,
  compact = false,
}) => {
  const { state } = useContext(AppContext);
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useClickOutside(menuRef, () => setIsOpen(false));
  const handleToggleMenu = () => setIsOpen((prev) => !prev);

  const handleVaultSelect = (vaultId: number) => {
    onVaultSelect(vaultId);
    setIsOpen(false);
  };

  return (
    <div className={styles.vaultSwitcherContainer} ref={menuRef}>
      <div
        className={classnames(styles.vaultDetailCard, {
          [styles.vaultDetailCardOpen]: isOpen,
          [styles.vaultDetailCardCompact]: compact,
        })}
      >
        <div
          className={classnames(styles.vaultDetailCardHeader, {
            [styles.vaultDetailCardHeaderCompact]: compact,
          })}
        >
          <VaultAvatar
            imageURL={vault?.coverThumbnailUrl}
            isLockedOrRestrictedVault={
              isLockedVault(vault) || isRestrictedVault(vault)
            }
            isSmall={compact}
          />
          {compact && (
            <div
              className={classnames(styles.vaultDetailCardContent, {
                [styles.vaultDetailCardContentCompact]: true,
              })}
              title={vault?.title}
            >
              {vault?.title || 'Vault name goes here'}
            </div>
          )}
          {state.logged && (
            <Button
              buttonStyle={ButtonStyle.PrimaryGhostLink}
              buttonSize={ButtonSize.Small}
              className={classnames(styles.chevronButton, {
                [styles.chevronButtonCompact]: compact,
              })}
              onClick={handleToggleMenu}
            >
              <ChevronSelectorVertical
                className={classnames(styles.chevronIcon, {
                  [styles.chevronIconCompact]: compact,
                })}
              />
            </Button>
          )}
        </div>
        {!compact && (
          <div className={styles.vaultDetailCardContent} title={vault?.title}>
            {vault?.title || 'Vault name goes here'}
          </div>
        )}
      </div>
      {isOpen && (
        <div className={styles.menuContainer}>
          <Menu currentVaultId={vault?.id} onVaultSelect={handleVaultSelect} />
        </div>
      )}
    </div>
  );
};
